import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

export enum SearchActions {
  makeModel = 'make_model',
  bodyStyle = 'body_style',
  price = 'price',
}

interface LegacySearchTapEventInfo {
  action: SearchActions;
}

function event({ action }: LegacySearchTapEventInfo): EventData {
  return {
    event_type: EventType.engagement,
    source_page: SourcePages.Home,
    feature: Features.legacySearch,
    engagement_type: `${action}_tap`,
  };
}

export default event;
